import React from 'react';

import validator from 'validator';
import { control } from 'react-validation';

export const noSpace = (value, props) => {
  if (validator.contains(value.toString(), ' ')) {
    return <div className="form-error">A senha não pode ter espaço</div>;
  }
};

export const alphaNum = (value) => {

  if (!validator.isAlphanumeric(validator.blacklist(value.toString().trim(), ' '))) {
    return <div className="form-error">Only a-z, A-Z and 0-9 allowed!</div>;
  }
};

export const numOnly = (value) => {
  if (!validator.isNumeric(value)) {
    return <div className="form-error">Only 0-9 allowed!</div>;
  }
};

export const required = (value, props) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="form-error">Este campo é obrigatório</div>;
  }

  if ((props.isCheckable && !props.checked)) {
    return <div className="form-error">required</div>;
  }
};

export const email = (value, props) => {
  const customRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!customRegEx.test(value)) {
    return <div className="form-error">{`${value} ` + 'Não é um email válido'}</div>;
  }
};

export const minChar6 = (value, props) => {
  // get the minLength from component's props
  if (value.length < 6) {
    // Return jsx
    return <div className="form-error">{"Mini 6 dígitos necessários"}</div>;
  }
};

export const passwordRegex = (value, props) => {
  if (!(/^.{4,64}$/.test(value))) {
    // Return jsx
    return <div className="form-error">{"A senha deve ter um caractere especial"}</div>;
  }
}

export const minChar8 = (value, props) => {
  // get the maxLength from component's props
  if (value.toString().trim().length < 8) {
    // Return jsx
    return <div className="form-error">São necessários 8 caracteres no mínimo</div>;
  }
};

export const lt = (value, props) => {
  // get the maxLength from component's props
  if (value.toString().trim().length > props.maxLength) {
    // Return jsx
    return <span className="error">cannot be more than {props.maxLength} characters.</span>;
  }
};

export const confirmPassword = (value, props, components) => {

  // NOTE: Tricky place. The 'value' argument is always current component's value.
  // So in case we're 'changing' let's say 'password' component - we'll compare it's value with 'confirm' value.
  // But if we're changing 'confirm' component - the condition will always be true
  // If we need to always compare own values - replace 'value' with components.password[0].value and make some magic with error rendering.
  if (components['password'][0].value !== components['confirmPassword'][0].value) { // components['password'][0].value !== components['confirm'][0].value
    // 'confirm' - name of input
    // components['confirm'] - array of same-name components because of checkboxes and radios
    return <div className="form-error">{"As senhas não coincidem"}</div>;
  }
};

// ----------------- custom input fields

const DisplayNameTemplate = ({ error, isChanged, isUsed, ...props }) => (
  <div className="form-group">
    <span className="input input--madoka">
      <input {...props} />
      <label className="input__label input__label--madoka" htmlFor="name">
        <svg className="graphic graphic--madoka" width="100%" height="100%" viewBox="0 0 404 77" preserveAspectRatio="none">
          <path d="m0,0l404,0l0,77l-404,0l0,-77z"></path>
        </svg>
        <span className="input__label-content input__label-content--madoka">{"Nome"}</span>
      </label>
    </span>
    {isChanged && isUsed && error}
  </div>
);

const NameTemplate = ({ error, isChanged, isUsed, ...props }) => (
  <div className="form-group">
    <span className="input input--madoka">
      <input {...props} />
      <label className="input__label input__label--madoka" htmlFor="userName">
        <svg className="graphic graphic--madoka" width="100%" height="100%" viewBox="0 0 404 77" preserveAspectRatio="none">
          <path d="m0,0l404,0l0,77l-404,0l0,-77z"></path>
        </svg>
        <span className="input__label-content input__label-content--madoka">{"Nome do usuário"}</span>
      </label>
    </span>
    {isChanged && isUsed && error}
  </div>
);

const EmailTemplate = ({ error, isChanged, isUsed, ...props }) => {
  var { ...otherProps } = props;
  return (
    <div className="form-group">
      <span className="input input--madoka">
        <input {...otherProps} />
        <label className="input__label input__label--madoka" htmlFor="email">
          <svg className="graphic graphic--madoka" width="100%" height="100%" viewBox="0 0 404 77" preserveAspectRatio="none">
            <path d="m0,0l404,0l0,77l-404,0l0,-77z"></path>
          </svg>
          <span className="input__label-content input__label-content--madoka">O-email</span>
        </label>
      </span>
      {isChanged && isUsed && error}
    </div>
  )
};

const PasswordTemplate = ({ error, isChanged, isUsed, ...props }) => {
  var { ...otherProps } = props;
  return (
    <div>
      <span className="input input--madoka">
        <input {...otherProps} />
        <label className="input__label input__label--madoka" htmlFor="password">
          <svg className="graphic graphic--madoka" width="100%" height="100%" viewBox="0 0 404 77" preserveAspectRatio="none">
            <path d="m0,0l404,0l0,77l-404,0l0,-77z"></path>
          </svg>
          <span className="input__label-content input__label-content--madoka">{"Senha"}</span>
        </label>
      </span>
      {isChanged && isUsed && error}
    </div>
  )
};

const NewPasswordTemplate = ({ error, isChanged, isUsed, ...props }) => (
  <div>
    <span className="input input--madoka">
      <input {...props} />
      <label className="input__label input__label--madoka" htmlFor="password">
        <svg className="graphic graphic--madoka" width="100%" height="100%" viewBox="0 0 404 77" preserveAspectRatio="none">
          <path d="m0,0l404,0l0,77l-404,0l0,-77z"></path>
        </svg>
        <span className="input__label-content input__label-content--madoka">Nova senha</span>
      </label>
    </span>
    {isChanged && isUsed && error}
  </div>
);

const ConfirmPasswordTemplate = ({ error, isChanged, isUsed, ...props }) => (
  <div>
    <span className="input input--madoka">
      <input {...props} />
      <label className="input__label input__label--madoka" htmlFor="confirmPassword">
        <svg className="graphic graphic--madoka" width="100%" height="100%" viewBox="0 0 404 77" preserveAspectRatio="none">
          <path d="m0,0l404,0l0,77l-404,0l0,-77z"></path>
        </svg>
        <span className="input__label-content input__label-content--madoka">Confirme a Senha</span>
      </label>
    </span>
    {isChanged && isUsed && error}
  </div>
);

const OTPTemplate = ({ error, isChanged, isUsed, ...props }) => (
  <div className="form-group">
    <span className="input input--madoka">
      <input {...props} />
      <label className="input__label input__label--madoka" htmlFor="otp">
        <svg className="graphic graphic--madoka" width="100%" height="100%" viewBox="0 0 404 77" preserveAspectRatio="none">
          <path d="m0,0l404,0l0,77l-404,0l0,-77z"></path>
        </svg>
        <span className="input__label-content input__label-content--madoka">OTP</span>
      </label>
    </span>
    {isChanged && isUsed && error}
  </div>
);

export const DisplayName = control(DisplayNameTemplate);
export const UserName = control(NameTemplate);
export const Email = control(EmailTemplate);
export const Password = control(PasswordTemplate);
export const NewPassword = control(NewPasswordTemplate);
export const ConfirmPassword = control(ConfirmPasswordTemplate);
export const OtpField = control(OTPTemplate);



// WEBPACK FOOTER //
// ./src/components/formValidation.js